/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Camera_Delete_ConfirmInputs */

const vi_camera_delete_confirm = /** @type {(inputs: Camera_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá hẳn camera "${i?.name}"? Camera sẽ biến mất khỏi mọi vùng trồng.`)
};

/**

* @param {Camera_Delete_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_delete_confirm = /** @type {((inputs: Camera_Delete_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Delete_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_delete_confirm(inputs)
});